import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { DocumentService } from '../../../../../services/document/document.service';

export interface FactureStatsData {
  factures_payees: { nombre: number; montant_total: number; ids?: any[] };
  factures_non_payees: { nombre: number; montant_total: number; ids?: any[] };
  factures_partiellement_payees: { nombre: number; montant_total: number };
  total_factures: { nombre: number; montant_total: number };
}

@Component({
  selector: 'app-fourniss-detail-chiffre-facture-fr',
  templateUrl: './fourniss-detail-chiffre-facture.component.html',
  styleUrls: ['./fourniss-detail-chiffre-facture.component.scss']
})
export class FournissDetailChiffreFactureComponent implements OnInit, OnChanges {

  @Input() fournisseurId: number | null = null;

  stats: FactureStatsData | null = null;
  loading = false;
  error: string | null = null;

  constructor(private documentService: DocumentService) {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['fournisseurId']) {
      this.loadStats();
    }
  }

  loadStats(): void {
    const id = this.fournisseurId != null ? Number(this.fournisseurId) : null;
    if (id == null || isNaN(id)) {
      this.stats = null;
      return;
    }
    this.loading = true;
    this.error = null;
    this.documentService.getStatsFournisseur(id).subscribe({
      next: (res) => {
        this.loading = false;
        if (res?.success && res?.data) {
          this.stats = res.data;
        } else {
          this.stats = null;
        }
      },
      error: (err) => {
        this.loading = false;
        this.stats = null;
        this.error = err?.error?.message || 'Erreur lors du chargement des statistiques.';
      }
    });
  }

  formatMontant(montant: number | null | undefined): string {
    if (montant == null || (typeof montant === 'number' && (isNaN(montant) || montant === 0))) {
      return '--';
    }
    return `${Number(montant).toFixed(3)} TND`;
  }
}
